import React from 'react';
import authRoles from '../../../auth/authRoles';
import StaffScheduleListing from './StaffScheduleListing';
import WorkshiftSchedules from './workshiftSchedules';
import PtoSchedules from './ptoSchedules';
import SickSchedules from './sickSchedules';
import EditWorkShiftSchedule from './editWorkShiftSchedule';
import EditPtoSchedule from './editPtoSchedule';
import EditSickSchedule from './editSickSchedule';

const StaffConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/staff-schedule',
			// component: StaffScheduleListing
			element: (
				<React.Suspense fallback={<>...</>}>
					<StaffScheduleListing />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-workshiftschedule',
			// component: workshiftSchedules
			element: (
				<React.Suspense fallback={<>...</>}>
					<WorkshiftSchedules />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-ptoschedule',
			// component: ptoSchedules
			element: (
				<React.Suspense fallback={<>...</>}>
					<PtoSchedules />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-sickschedule',
			// component: sickSchedules
			element: (
				<React.Suspense fallback={<>...</>}>
					<SickSchedules />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-editwork-shiftschedule',
			// component: editWorkShiftSchedule
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditWorkShiftSchedule />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-editptoschedule',
			// component: editPtoSchedule
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditPtoSchedule />
				</React.Suspense>
			),
		},
		{
			path: '/staff-schedule-editsickschedule',
			// component: editSickSchedule
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditSickSchedule />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.subadmin,
};

export default StaffConfig;
